import styled from "styled-components";

// Both boundary fallbacks sit in PageWrapper's content area, which has no height of
// its own, so they carry their own vertical room.
export const Centered = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  min-height: 60vh;
`;
